module.exports = __webpack_public_path__ + "img/bmchemie.a8839c30.webp";